module.exports = "dist/assets/images/patty.ba552648c2cae5f80aec6fb8e6c5f4e5.svg";